export default {
    figures: {
        cad: {
            dialogTitle: 'CAD轉專利線圖',
            close: '關閉',
            uploadTitle: '匯入3D檔案',
            uploadDesc: '支援 STEP、STP、IGES、IGS、STL、OBJ、PLY、GLTF、GLB 格式',
            selectFile: '選擇檔案',
            unsupportedFormat: '不支援的檔案格式',
            insertSuccess: '已插入到附圖',
            insertFailed: '插入附圖失敗',
            insert: '儲存到附圖',
            modeStandard: '標準',
            modePatent: '專利',
            lineWidth: '線寬',
            hatching: '陰影線',
            hatchingGap: '陰影線間距',
            edgeThreshold: '邊緣閾值',
            clipToggle: '剖切面',
            clipFlip: '翻轉',
            explodeToggle: '爆炸圖',
            explodeUnsupported: '目前模型為單體結構，不支援爆炸圖',
            explodeAxisView: '視角',
            loadingParser: '初始化解析器...',
            loadingModel: '解析模型中...',
            loadingGeneric: '載入中...',
            noGeometryParsed: '未能從該檔案中解析出可用幾何，可能是模型未縫合成實體',
            errUnsupportedFormat: '不支援的檔案格式，請上傳 STEP、STP、IGES、IGS、STL、OBJ、PLY、GLTF 或 GLB 檔案',
            errOutOfMemory: '模型過於複雜，瀏覽器記憶體不足，載入失敗。建議在 CAD 軟體中簡化模型、減少零件數量，或匯出為 STL 後重試',
            errParseFailed: '檔案解析失敗，可能已損壞或不是有效的該格式檔案',
            errFileReadFailed: '讀取檔案失敗，請確認檔案仍存在後重試',
            errUnknown: '載入失敗，請重試或更換檔案',
            errWorkerUnavailable: '目前瀏覽器不支援背景解析，請更換或升級瀏覽器後重試',
            loadingTransferring: '建構幾何...',
            errParseTimeout: '解析逾時（超過 5 分鐘未完成），已停止。該模型的零件數或幾何複雜度過高，建議在 CAD 軟體中簡化模型、僅保留需要的零件，或先匯出為 STL 再上傳。',
            stuckHint: '解析時間已明顯超出預期，可能是模型零件數過多或幾何過於複雜。若 5 分鐘內仍未完成將自動停止。建議在 CAD 軟體中簡化模型、僅保留需要的零件，或先匯出為 STL 再上傳。',
            errParserInitTimeout: '解析器載入失敗，可能是網路問題導致資源未能下載完整。請檢查網路後重新整理頁面再試',
            largeFileHint: '檔案較大（{size}），解析可能需要數十秒，請耐心等待',
        },
        canvas: {
            loading: '圖片刷新中，請耐心等候...',
            aiUpdating: 'AI 正在編輯附圖...',
            emptyTitle: '開始描述你想要的附圖',
            emptyDesc: '在右側對話框中輸入詳細描述',
            annotationInfo: {
                button: '標號',
                loading: '載入中…',
                empty: '此圖暫無標引資訊',
                numeralHeader: '標號',
                componentHeader: '部件名',
                editHint: '點擊部件名可編輯',
                addRow: '新增標號',
                addNumeralPlaceholder: '標號（數字）',
                addComponentPlaceholder: '部件名',
                addComponentReuseHint: '已存在，將使用現有部件名',
                addCancel: '取消',
                addConfirm: '新增',
                deleteConfirm: '從本圖移除標號 {numeral}？',
                deleteCancel: '取消',
                deleteOk: '移除',
                errorNumeralFormat: '標號僅允許純數字或數字+字母',
                errorNumeralRequired: '請填寫標號',
                errorComponentRequired: '請填寫部件名',
            },
        },
        annotationConfirm: {
            reconfirmBanner: '此專案已有確認的標引對照表，目前為重新調整模式',
            defaultTitle: '請確認標引對照表',
            colNumeral: '標號',
            colFeature: '特徵（部件名）',
            colFigures: '適用附圖',
            colEmbodiment: '實施例',
            colAnchor: '標引重點',
            figuresEmpty: '（未選擇）',
            embodimentPlaceholder: '如：第一實施例',
            addRow: '＋ 新增標引項',
            confirm: '確認並開始標引',
            confirmed: '已確認',
            warnNumeralDup: '標號 "{numeral}" 重複',
            warnComponentDup: '特徵名 "{name}" 重複，請確認是否正確',
            warnNewRowNoFigure: '新增行必須選擇適用附圖',
            warnNoFigure: '未選擇適用附圖，將適用所有圖',
            submitHint: '已確認標引對照表，共 {count} 項',
            submitHintNext: '，請開始標引第一張：{figureNo}',
        },
        fineTune: {
            button: '微調',
            preparing: '準備中',
            title: '局部微調',
            close: '關閉',
            placeholder: '描述希望模型如何修改選中的區域...',
            selectionCount: '已選擇 {count} 個網格',
            clear: '清空',
            addOperation: '新增要求',
            submitAll: '提交全部',
            operationTitle: '要求 {index}',
            remove: '刪除要求',
        },
        maskEdit: {
            title: 'Mask 圖片編輯',
            preparing: '正在準備編輯...',
            notSupported: '該圖片暫不支援 AI 編輯，請先儲存後重試',
            hint: '塗抹想要編輯的區域',
            brushSize: '筆刷大小',
            undo: '撤銷上一筆',
            clear: '清空重畫',
            placeholder: '描述想如何修改這個區域...',
            close: '關閉',
            cancel: '取消',
            submit: '提交',
        },
        panel: {
            title: '附圖編輯器',
            reset: '重置',
            submit: '儲存',
            newFigureGenerated: '新附圖已生成並加入縮略圖列表，目前圖有未儲存修改，暫未自動切換。',
            unsavedChanges: '目前附圖有未儲存修改。切換後這些修改不會自動儲存，確認繼續嗎？',
            unsavedChangesTitle: '未儲存修改',
            continueSwitch: '繼續切換',
            cancel: '取消',
            resetConfirmTitle: '重置確認',
            resetConfirm: '確認丟棄目前修改，恢復到上次儲存的狀態？',
            confirmReset: '確認重置',
            uploadFailed: '上傳失敗：{fileName}',
            renameFailed: '重命名失敗，請稍後重試',
        },
        uploadDialog: {
            title: '上傳附圖',
            aiGenerate: 'AI生成',
            aiGenerateDesc: '通過AI生成專業附圖',
            normalUpload: '普通上傳',
            normalUploadDesc: '從本地上傳圖片檔案',
            fromFile: '來自檔案',
            fromFileDesc: '從已上傳的檔案中選擇',
            cadImport: '3D模型匯入',
            cadImportDesc: '上傳 STEP/STL 等 3D 檔案，轉為專利線稿',
            editFigure: '編輯附圖',
        },
        vsdx: {
            converting: '正在轉換 Visio 檔案...',
            success: '轉換成功，已產生 {count} 張附圖',
            partialSuccess: '已產生 {success} 張附圖，{failed} 頁轉換失敗',
            failed: 'Visio 轉換失敗',
            legacyUnsupported: '暫不支援 .vsd/.vdx/.vss 格式，請在 Visio 中另存為 .vsdx 後再上傳',
        },
        attachmentPicker: {
            title: '選擇附件圖片',
            subtitle: '可選擇專案附件中的原圖，或文件/PDF 中提取出的圖片',
            addToCanvasSubtitle: '點擊選擇圖片，添加到畫布上',
            empty: '目前專案附件中暫無可用圖片',
            loadFailed: '載入附件圖片失敗，請稍後再試',
            importFailed: '匯入附件圖片失敗，請稍後再試',
            sourcePrefix: '來源：',
            tableImage: '表格圖片',
            selectedCount: '已選擇 {count} 張圖片',
            cancel: '取消',
            confirm: '確定',
        },
        collapsePanel: '收起',
        exportPdf: '匯出 PDF',
        chat: {
            title: 'Hiro',
            historyTitle: '歷史對話',
            newChat: '新對話',
            languageLabel: '模型輸出語言',
            welcome: '你好！我可以幫你生成各種技術附圖。描述你想要的附圖內容，我會根據你的需求生成專業的圖紙。',
            suggestedTasksWithFigures: [
                { title: '一致性檢查', desc: '掃描所有 Fig 標注與說明書的對應關係', prompt: '請檢查所有附圖標注與說明書的一致性' },
                { title: '生成附圖說明', desc: '基於當前所有 Fig 標注一鍵生成文字', prompt: '請基於當前所有附圖標注生成附圖說明' },
                { title: '編號管理', desc: '批量重新命名/調整順序/同步引用', prompt: '請幫我批量管理附圖編號，包括重新命名、調整順序和同步引用' },
            ],
            suggestedTasksNoFigures: [
                { title: '根據交底書/權利要求/說明書生成附圖', desc: '從現有材料自動提取技術方案生成 Fig', prompt: '請根據交底書/權利要求/說明書生成附圖' },
                { title: '優化並補齊現有附圖', desc: '上傳已有附圖，自動優化並補充缺失 Fig', prompt: '請優化並補齊現有附圖' },
                { title: '繪製所有附圖', desc: '從零開始描述需求，逐一生成全套附圖', prompt: '請從零開始幫我繪製所有附圖' },
            ],
            inputPlaceholder: '描述你想要的附圖內容，輸入 {\'@\'} 引用資源...',
            mentionResource: '引用資源',
            awaitingGeneration: '附圖正在生成中，請稍候...',
            fineTunePrompt: {
                targetFigure: '目標附圖：{figureName}',
                targetFileId: '目標附圖 file_id：{fileId}',
                gridRule: '網格規則：目標附圖會被劃分為 10x10 網格，行 A-J 從上到下，列 1-10 從左到右；A1 是左上角，J10 是右下角。',
                editTarget: '調用 draw_patent_figures 時，請將該 file_id 放入 file_ids_to_edit，用它作為本次編輯目標。',
                instruction: '請僅針對目標附圖「{figureName}」中以下 10x10 網格區域進行局部微調，不要修改其他附圖。',
                selectedCells: '{index}. 選中區域：{cells}',
                modifyRequirement: '   修改要求：{instruction}',
            },
            maskEditPrompt: {
                targetFigure: '目標附圖：{figureName}',
                instruction: '請僅針對塗抹標記的區域進行局部編輯：{instruction}',
            },
            history: {
                title: '歷史對話',
                empty: '暫無歷史對話',
                search: '搜尋對話...',
                rename: '重新命名',
                delete: '刪除',
                defaultTitle: '新對話',
                today: '今天',
                yesterday: '昨天',
                lastWeek: '最近一週',
                lastMonth: '最近一個月',
                older: '更早',
            },
        },
    },
};
